// Helper function to round numbers
const mr = (num, scale = 2) => {
    if (!num) return 0;
    return +(Math.round(num + "e+" + scale) + "e-" + scale);
};
export const validateInputs = (form) => {
    if (!form.stockName.trim() || +form.holdUnit <= 0 || +form.avgPrice <= 0 || +form.newAmount <= 0 || +form.currPrice <= 0) {
        return "All fields are required, and numeric values must be positive.";
    }
    return '';
};

export const calculateStockData = (form) => {
    const currInvest = mr(+form.holdUnit * +form.avgPrice);
    const newUnit = mr(+form.newAmount / +form.currPrice);
    const newAvg = mr((currInvest + +form.newAmount) / (+form.holdUnit + newUnit));
    const benefit = mr(+form.avgPrice - newAvg);
    const riskReward = mr(((benefit * (+form.holdUnit + newUnit)) / (+form.newAmount + currInvest)) * -100);
    return { ...form, currInvest, newUnit, newAvg, benefit, riskReward };
};

export const saveRowsToLocalStorage = (rows) => {
    try {
        localStorage.setItem('stockRows', JSON.stringify(rows));
    } catch (error) {
        console.error('Error saving data to localStorage:', error);
        alert('An error occurred while saving your data.');
    }
};

export const loadRowsFromLocalStorage = () => {
    try {
        const savedRows = localStorage.getItem('stockRows');
        return savedRows ? JSON.parse(savedRows) : [];
    } catch (error) {
        console.error('Error loading data from localStorage:', error);
        alert('An error occurred while loading your data. Starting with an empty table.');
        return [];
    }
};
